// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { fileSchema } from '@/file/api/types';
import { z } from 'zod';

const projectFilesResponseSchema = z.object({
  data: z.array(fileSchema),
  metadata: responseMetadataSchema,
});

/**
 * Requests a collection of files for a project from the remote API.
 *
 * @param key - The key of the project for which to request files.
 */
export async function getProjectFiles(key: string) {
  const path = `/v1/project/${key}/file`;
  const response = await api.get(path);

  return parseResponse(projectFilesResponseSchema, response.data, {
    schemaName: 'ProjectFiles',
    endpoint: path,
  });
}
